var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBridgeToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2686 2.10183C11.6265 1.74385 12.2069 1.74385 12.5649 2.10183L15.3149 4.85183C15.6729 5.20981 15.6729 5.79021 15.3149 6.14819L12.5649 8.89819C12.2069 9.25617 11.6265 9.25617 11.2686 8.89819C10.9106 8.54021 10.9106 7.95981 11.2686 7.60183L12.4537 6.41668H7.33341C6.32089 6.41668 5.50008 7.23749 5.50008 8.25001V11.9167C5.50008 12.4229 5.08968 12.8333 4.58341 12.8333C4.07715 12.8333 3.66675 12.4229 3.66675 11.9167V8.25001C3.66675 6.22497 5.30837 4.58334 7.33341 4.58334H12.4537L11.2686 3.39819C10.9106 3.04021 10.9106 2.45981 11.2686 2.10183ZM17.4167 9.16668C17.923 9.16668 18.3334 9.57708 18.3334 10.0833V13.75C18.3334 15.7751 16.6918 17.4167 14.6667 17.4167H9.54644L10.7316 18.6018C11.0896 18.9598 11.0896 19.5402 10.7316 19.8982C10.3736 20.2562 9.79321 20.2562 9.43523 19.8982L6.68523 17.1482C6.32725 16.7902 6.32725 16.2098 6.68523 15.8518L9.43523 13.1018C9.79321 12.7438 10.3736 12.7438 10.7316 13.1018C11.0896 13.4598 11.0896 14.0402 10.7316 14.3982L9.54644 15.5833H14.6667C15.6793 15.5833 16.5001 14.7625 16.5001 13.75V10.0833C16.5001 9.57708 16.9105 9.16668 17.4167 9.16668Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgeToken);
export default __webpack_public_path__ + "static/media/bridgeToken.0bf9db9591c2590d57025fbad5ace983.svg";
export { ForwardRef as ReactComponent };